module.exports = __webpack_public_path__ + "static/media/2018-image.f7ba0975.png";